import React from "react";
import {NullOrEmpty} from "modules/types";
import {IMAGES_URL} from "modules/constants";
import {Exist} from "components/Exists";
import emptyPlayer from "assets/images/emptyPlayer.svg";
import styled from "@emotion/styled";

const JerseyImage = styled.img`
	height: 100%;
`;

interface IProps {
	image: NullOrEmpty<string>;
	alt: string;
	customClass?: string;
}

export const Jersey: React.FC<IProps> = ({image, alt, customClass = ""}) => {
	const className = `jersey ${customClass}`;

	return (
		<React.Fragment>
			<Exist when={Boolean(image)}>
				<JerseyImage src={`${IMAGES_URL}${image || ""}`} alt={alt} className={className} />
			</Exist>
			<Exist when={!image}>
				<JerseyImage src={emptyPlayer} alt={alt} className={className} />
			</Exist>
		</React.Fragment>
	);
};
